export class ScrollToHelper {
    public static scrollToAnchor() {
        if (this.scrollToElement('#job-center-anchor')) {
            return;
        }
        if (this.scrollToElement('#job-center')) {
            return;
        }

        console.debug('[JobCenter] Scroll to top');
        window.scrollTo(0, 0);
    }

    public static scrollToElement(selector: string) {
        const element = document.querySelector(selector);
        if (!element) {
            return false;
        }
        const boundingClientRect = element.getBoundingClientRect();
        const newScrollY = boundingClientRect.top + window.scrollY;
        console.debug(
            `[JobCenter] Scroll to element '${selector}' ${newScrollY}`,
            element,
            boundingClientRect
        );
        window.scrollTo(0, newScrollY);

        return true;
    }
}
